import { render, staticRenderFns } from "./AuftragPositionModal.vue?vue&type=template&id=32cf8e4b"
import script from "./AuftragPositionModal.vue?vue&type=script&lang=js"
export * from "./AuftragPositionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports